var React = require('react');

function InfoDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.75781 8.92188C1.75781 5.33187 4.66781 2.42188 8.25781 2.42188C11.8478 2.42188 14.7578 5.33187 14.7578 8.92188C14.7578 12.5119 11.8478 15.4219 8.25781 15.4219C4.66781 15.4219 1.75781 12.5119 1.75781 8.92188ZM3.25781 8.92188C3.25781 11.6789 5.50081 13.9219 8.25781 13.9219C11.0148 13.9219 13.2578 11.6789 13.2578 8.92188C13.2578 6.16488 11.0148 3.92188 8.25781 3.92188C5.50081 3.92188 3.25781 6.16488 3.25781 8.92188ZM8.68598 5.30309L7.24871 5.68444L7.63006 7.12171L9.06733 6.74036L8.68598 5.30309ZM8.97931 7.67988H7.49281V12.5399H8.97931V7.67988Z","fill":"#044D29"}));
}

InfoDark.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = InfoDark;

InfoDark.default = InfoDark;
